/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { StartPaymentCoursePriceCloseTabData } from './StartPaymentCoursePriceCloseTabData';
import { StartPaymentCoursePriceRedirectData } from './StartPaymentCoursePriceRedirectData';
const StartPaymentCoursePriceDataParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('mode', [
    ['redirect', StartPaymentCoursePriceRedirectData],
    ['close_tab', StartPaymentCoursePriceCloseTabData],
]);
export const StartPaymentCoursePriceData = StartPaymentCoursePriceDataParser;
